import styled from 'styled-components';

import {
    CONTENT_BACKUP,
} from '@amzn/ring-common-style-library/lib/colors';
import { 
    FOOTNOTE_XSMALL_LIGHT,
} from '@amzn/ring-common-style-library/lib/typography';

const Entry = styled.div<{
    customer?: boolean;
}>`
    display: flex;
    flex-direction: column;
    align-items: ${({ customer }) => (customer ? 'flex-end' : 'flex-start')};
    justify-content: ${({ customer }) => (customer ? 'flex-end' : 'flex-start')};
    width: 100%;
    gap: 8px;
`;

const IndicatorWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin: 8px 0px -4px 0px;
    align-items: center;
    gap: 8px;
`;

const IndicatorIcon = styled.div`
    display: flex;
    height: 24px;
    width: 24px;
    border-radius: 50px;
`;

const Timestamp = styled.div<{
    customer?: boolean;
}>`
    display: flex;

    flex-direction: ${({ customer }) => (customer ? 'row' : 'row-reverse')};
    align-items: center;

    color: ${CONTENT_BACKUP};
    ${FOOTNOTE_XSMALL_LIGHT};
`;

export default {
    Entry,
    IndicatorIcon,
    IndicatorWrapper,
    Timestamp,
}